/**
 * UI color scheme
 * @module colors
 */

import themeColors from './theme-colors'
import config from './config'

let localData = localStorage.getItem(config.localStorageEntryName)

if (localData) {
  localData = JSON.parse(localData)
}

const colors = localData ? localData.colors : {
  primary: themeColors.red.primary,
  primaryText: themeColors.red.primaryText
}

export default colors



// WEBPACK FOOTER //
// ./src/helpers/colors.js